import React from 'react';
import { Form, App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import CardLayout from '../../../layouts/CardLayout';
import { ContractorForm } from '../../../components/Contractor/ContractorForm';
import { CONTRACTOR_CREATE } from '../../../graphql/mutations/contractors';
import { ContractorFormValues } from '../../../types/contractor';

const ContractorCreate: React.FC = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm<ContractorFormValues>();

  const [createContractor, { loading }] = useMutation(CONTRACTOR_CREATE, {
    onCompleted: data => {
      if (data?.contractorCreate) {
        message.success('Contractor created successfully');
        navigate(`/admin/contractor/${data.contractorCreate.id}`);
      }
    },
    onError: error => {
      message.error(error.message || 'Failed to create contractor');
    },
  });

  const handleFinish = (values: ContractorFormValues) => {
    createContractor({
      variables: {
        input: values,
      },
    });
  };

  return (
    <CardLayout>
      <ContractorForm
        form={form}
        loading={loading}
        onFinish={handleFinish}
        submitText="Create Contractor"
        showUserField
      />
    </CardLayout>
  );
};

export default ContractorCreate;
